import React, {Component} from 'react';
import InputMask from 'react-input-mask';
import NumberFormat from 'react-number-format';

import './styles.scss';

class InputText extends Component {
  renderInput = () => {
    return (
      <div className="form-group">
        <input {...this.props} className="form-field" />
        <label htmlFor={this.props.id} className="form-label">
          {this.props.placeholder}
        </label>
      </div>
    );
  };

  renderInputMask = () => {
    return (
      <div className="form-group">
        <InputMask {...this.props} className="form-field" />
        <label htmlFor={this.props.id} className="form-label">
          {this.props.placeholder}
        </label>
      </div>
    );
  };

  renderInputNumber = () => {
    return (
      <div className="form-group">
        <NumberFormat {...this.props} className="form-field" />
        <label htmlFor={this.props.id} className="form-label">
          {this.props.placeholder}
        </label>
      </div>
    );
  };

  render = () => {
    const {mask, type} = this.props;
    return !mask
      ? type === 'number' || type === 'tel' || type === 'currency'
        ? this.renderInputNumber()
        : this.renderInput()
      : this.renderInputMask();
  };
}

export default InputText;
